import { TOGGLE_MINI_PLAYER } from '../constants/MiniPlayer';

export function toggleMiniPlayer() {
  return {
    type: TOGGLE_MINI_PLAYER
  };
}
